import type { SchemaColumn, SchemaField } from '@cli-types/core-engine/schema.js'
import { fieldHasMediaCompanion } from './field-has-media-companion.js'

export function buildImageUrlExpression(
  column: SchemaColumn,
  fields: SchemaField[],
  fallbackExpression: string
): string {
  const fallback = `(${fallbackExpression} as string | null | undefined)`

  if (!fieldHasMediaCompanion(column, fields)) {
    return fallback
  }

  return `row.original.${column.accessorKey}Media?.url ?? ${fallback}`
}
